import { inject, Injectable } from '@angular/core';
import { I18nService } from 'shared/module/i18n/i18n.service';
import { Observable, zip } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class StartUpService {

  private i18nSvc = inject(I18nService);

  /**
   * Initializes the application startup sequence by setting up required configurations.
   * Combines multiple asynchronous setup operations into one observable stream.
   *
   * @return {Observable<any>} An observable that emits when all setup operations are completed.
   */
  startUp(): Observable<unknown> {
    return zip([
      this.translations()
      //, and other setups
    ]);
  }

  /**
   * Loads and retrieves translation resources for the application.
   *
   * @return {Observable<any>} An observable emitting the loaded translation resources from specified paths.
   */
  private translations(): Observable<unknown> {
    return this.i18nSvc.loadResources([
      'assets/i18n/cs-CZ.json',
      // 'assets/i18n/sk-SK.json',
      'assets/i18n/en-US.json'
    ]);
  }
}

export function appInitFactory(startupSvc: StartUpService) {
  return () => startupSvc.startUp();
}
